// extracted by mini-css-extract-plugin
export default {"actions":"ModalActions_actions__D5Dg0"};